// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"CheckboxFilter_checkbox__2qiOE","list":"CheckboxFilter_list__1bqO-","selectAll":"CheckboxFilter_selectAll__1aiVo"};